/**
 * @Author : ShaJiaJing
 * @Date : 2019/10/9
 * @Version : 1.0
 * @Content : 应用管理
 */
import fetch from '@/utils/fetch2'

// 应用列表
export function getAppList (params) {
  return fetch.get('/mylicense', params)
}

// 获取应用许可数量
export function getAppNums () {
  return fetch.get('/mylicense/count')
}

// 删除应用
export function deleteApp (id) {
  return fetch.delete('/mylicense', { id })
}

/**
 * 新增应用
 * @param appName 应用名称
 * @param appDesc 应用描述
 * @returns {*}
 */
export function addApp (params) {
  return fetch.post('/mylicense', JSON.stringify(params))
}

/**
 * 获取用量列表
 * @param payTimeBeg 开始日期
 * @param payTimeEnd 结束日期
 * @returns {*}
 */
export function getDosage (params) {
  return fetch.get('/api/total', params)
}

// 获取服务列表
export function getServiceList (params) {
  return fetch.get('/api/service', params)
}
